import { Component } from '@abiglobalhealth/go-types'
import React, { useCallback } from 'react'

import { COMPONENTS } from '@/components/ComponentsLayout/constants'
import { useUser } from '@/hooks/useUser'
import { useUserForm } from '@/hooks/useUserForm'
import { skipComponent } from '@/utils/isFieldFilled'

interface UseGetComponentProps {
  getComponent: (component: Component) => ((props: any) => React.JSX.Element | null) | null
}

export const useGetComponent = (): UseGetComponentProps => {
  const { user } = useUser()
  const { userUpdatedFields } = useUserForm()

  const getComponent: UseGetComponentProps['getComponent'] = useCallback(
    (component: Component) => {
      // Always return component if not hideable
      if (!('hideIfFilled' in component) || !component.hideIfFilled) return COMPONENTS[component.componentType]

      // Return only if hideable and already filled
      return skipComponent({
        component,
        user: user!,
        userUpdatedFields
      })
        ? null
        : COMPONENTS[component.componentType]
    },
    [user, userUpdatedFields]
  )

  return {
    getComponent
  }
}
